<template>
    <div
        v-if="showIcon"
        class="max-mob:hidden w-8 h-8 rounded-custom flex justify-center items-center hover:bg-purple-70 dark:hover:bg-blue-770 cursor-pointer transition-colors"
        :class="showDownloadPopup ? 'bg-gray-80 dark:bg-purple-700' : 'bg-transparent'"
        @click="changeShowDownloadPopup"
    >
        <component
            :is="currentIcon"
            class="text-gray-370 dark:text-white"
        />
    </div>
</template>

<script setup>
import { computed, markRaw } from 'vue'

import AnimationDownloadIcon from '@/components/icons/download/AnimationDownloadIcon.vue'
import FailDownloadIcon from '@/components/icons/download/FailDownloadIcon.vue'
import SuccessDownloadIcon from '@/components/icons/download/SuccessDownloadIcon.vue'

import { useDownloadReportingStore } from '@/store/download/downloadReportingStore'
import { useDownloadLeadsStore } from '@/store/download/downloadLeadsStore'

defineProps({
    showDownloadPopup: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['changeShowDownloadPopup'])

const downloadReportingStore = useDownloadReportingStore()
const downloadLeadsStore = useDownloadLeadsStore()

const allStatuses = computed(() => [
    downloadReportingStore.downloadingLogStatus,
    downloadReportingStore.downloadingAggregateStatus,
    downloadLeadsStore.downloadingLeadsStatus,
])

const showIcon = computed(() => allStatuses.value.some((status) => status !== null))

const someFailed = computed(() => allStatuses.value.some((status) => status === 'failed'))

const someInProgress = computed(() => allStatuses.value.some((status) => status === 'in_process'))

const currentIcon = computed(() => {
    switch (true) {
    case someFailed.value:
        return markRaw(FailDownloadIcon)
    case someInProgress.value:
        return markRaw(AnimationDownloadIcon)
    default:
        return markRaw(SuccessDownloadIcon)
    }
})

function changeShowDownloadPopup() {
    emits('changeShowDownloadPopup')
}
</script>
